module.exports = __webpack_public_path__ + "static/media/banner.70abe19a.png";